<template>
  <div class="page-XLtimerShaft">
    <div class="shell" id="shell">
      <div class="timeline">
        <div
          v-for="(item, index) in NewsList"
          :key="index"
          class="item"
          :data-text="item.title"
        >
          <div class="content" @click="handleDetails(item.id)">
            <img
              :src="
                'http://puchuang-admin.coredataos.com/prod-api/' + item.cover
              "
              alt=""
              class="XLtimerShaft-img"
            />
            <h2 class="content-title">{{ item.releaseTime }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "XLtimerShaft",
  props: {
    NewsList: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    NewsList(val) {
      if (val) {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
  },
  methods: {
    handleDetails(id) {
      this.$router.push({ path: "/newsDetails", query: { id: id } });
    },
    init() {
      $.fn.timeline = function () {
        var selectors = {
          id: $(this),
          item: $(this).find(".item"),
          activeClass: "item--active",
        };
        console.log(selectors.item.eq(0));
        // 将第一个时间轴项目激活，并设置时间轴背景图片为第一个项目的图片
        selectors.item.eq(0).addClass(selectors.activeClass);
        // 获取时间轴项目的总数
        var itemLength = selectors.item.length;
        // 当页面滚动时，触发滚动事件
        $(window).scroll(function () {
          var max, min;
          // 获取页面滚动的距离
          var pos = $(this).scrollTop();
          selectors.item.each(function (i) {
            // 获取当前时间轴项目的最小和最大高度
            min = $(this).offset().top;
            max = $(this).height() + $(this).offset().top;
            // 如果滚动到最后一个项目，并且超过了当前项目高度的一半，
            // 则将最后一个项目设置为激活状态，并设置背景图片为最后一个项目的图片
            if (i == itemLength - 2 && pos > min + $(this).height() / 2) {
              selectors.item.removeClass(selectors.activeClass);
              selectors.item.last().addClass(selectors.activeClass);
            }
            // 如果当前滚动位置在当前项目的最小和最大高度之间，
            // 则将当前项目设置为激活状态，并设置背景图片为当前项目的图片
            else if (pos <= max - 10 && pos >= min) {
              console.log(pos, max - 10, min);
              selectors.item.removeClass(selectors.activeClass);
              $(this).addClass(selectors.activeClass);
            }
          });
        });
      };
      if (this.disabled) {
        $("#shell").timeline();
      } else {
        let dom = $(".item");
        for (const item of dom) {
          item.classList.add("item--active");
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
@import "../style/index.css";
</style>
